module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Uezwil-68a4759f0e61672d9001f754fba058d6.svg";